import { API } from "services/enum/api";
import { fetchData } from "services/fetcher";

const serviceLogin = async (data: LoginParamsType): Promise<LoginResponseType> => {
  return await fetchData(API.LOGIN, { method: 'POST', body: JSON.stringify(data) });
};

export {
  serviceLogin,
}